import React, { useState, useEffect } from 'react'
import '../Styles/D_Resume.css'
import { FileUploader } from "react-drag-drop-files";
import axios from 'axios';
export default function D_Resume() {
    const [edit, setEdit] = useState(false)
    var countryCodes = {
        "IN": "91", "AU": "61", "SA": "966", "GR": "30", "HU": "36", "AT": "43", "SJ": "47", "NL": "31",
        "IT": "39", "BD": "880", "BE": "32", "BF": "226", "BG": "359", "BA": "387", "BB": "+1-246",
        "WF": "681", "BL": "590", "BM": "+1-441", "BN": "673", "BO": "591", "BH": "973", "BI": "257", "BJ": "229",
        "BT": "975", "JM": "+1-876", "BV": "", "BW": "267", "WS": "685", "BQ": "599", "BR": "55", "BS": "+1-242",
        "JE": "+44-1534", "BY": "375", "BZ": "501", "RU": "7", "RW": "250", "RS": "381", "TL": "670", "RE": "262",
        "TM": "993", "TJ": "992", "RO": "40", "TK": "690", "GW": "245", "GU": "+1-671", "GT": "502", "GS": "",
        "GQ": "240", "GP": "590", "JP": "81", "GY": "592", "GG": "+44-1481", "GF": "594", "GE": "995",
        "GD": "+1-473", "GB": "44", "GA": "241", "SV": "503", "GN": "224", "GM": "220", "GL": "299", "GI": "350",
        "GH": "233", "OM": "968", "TN": "216", "JO": "962", "HR": "385", "HT": "509", "HK": "852",
        "HN": "504", "HM": " ", "VE": "58", "PR": "+1-787 and 1-939", "PS": "970", "PW": "680", "PT": "351",
        "PY": "595", "IQ": "964", "PA": "507", "PF": "689", "PG": "675", "PE": "51", "PK": "92",
        "PH": "63", "PN": "870", "PL": "48", "PM": "508", "ZM": "260", "EH": "212", "EE": "372", "EG": "20",
        "ZA": "27", "EC": "593", "VN": "84", "SB": "677", "ET": "251", "SO": "252", "ZW": "263",
        "ES": "34", "ER": "291", "ME": "382", "MD": "373", "MG": "261", "MF": "590", "MA": "212",
        "MC": "377", "UZ": "998", "MM": "95", "ML": "223", "MO": "853", "MN": "976", "MH": "692", "MK": "389",
        "MU": "230", "MT": "356", "MW": "265", "MV": "960", "MQ": "596", "MP": "+1-670", "MS": "+1-664",
        "MR": "222", "IM": "+44-1624", "UG": "256", "TZ": "255", "MY": "60", "MX": "52", "IL": "972", "FR": "33",
        "IO": "246", "SH": "290", "FI": "358", "FJ": "679", "FK": "500", "FM": "691", "FO": "298", "NI": "505",
        "NO": "47", "NA": "264", "VU": "678", "NC": "687", "NE": "227", "NF": "672", "NG": "234",
        "NZ": "64", "NP": "977", "NR": "674", "NU": "683", "CK": "682", "XK": "", "CI": "225", "CH": "41",
        "CO": "57", "CN": "86", "CM": "237", "CL": "56", "CC": "61", "CA": "1", "CG": "242", "CF": "236",
        "CD": "243", "CZ": "420", "CY": "357", "CX": "61", "CR": "506", "CW": "599", "CV": "238", "CU": "53",
        "SZ": "268", "SY": "963", "SX": "599", "KG": "996", "KE": "254", "SS": "211", "SR": "597", "KI": "686",
        "KH": "855", "KN": "+1-869", "KM": "269", "ST": "239", "SK": "421", "KR": "82", "SI": "386", "KP": "850",
        "KW": "965", "SN": "221", "SM": "378", "SL": "232", "SC": "248", "KZ": "7", "KY": "+1-345", "SG": "65",
        "SE": "46", "SD": "249", "DO": "+1-809 and 1-829", "DM": "+1-767", "DJ": "253", "DK": "45", "VG": "+1-284",
        "DE": "49", "YE": "967", "DZ": "213", "US": "1", "UY": "598", "YT": "262", "UM": "1", "LB": "961",
        "LC": "+1-758", "LA": "856", "TV": "688", "TW": "886", "TT": "+1-868", "TR": "90", "LK": "94", "LI": "423",
        "LV": "371", "TO": "676", "LT": "370", "LU": "352", "LR": "231", "LS": "266", "TH": "66", "TF": "",
        "TG": "228", "TD": "235", "TC": "+1-649", "LY": "218", "VA": "379", "VC": "+1-784", "AE": "971",
        "AD": "376", "AG": "+1-268", "AF": "93", "AI": "+1-264", "VI": "+1-340", "IS": "354", "IR": "98",
        "AM": "374", "AL": "355", "AO": "244", "AQ": "", "AS": "+1-684", "AR": "54",
        "AW": "297", "AX": "+358-18", "AZ": "994", "IE": "353", "ID": "62", "UA": "380", "QA": "974", "MZ": "258"
    }
    const ResDet = () => {
        return <>
            <table>
                {data.first_name != '' ? <><tr>
                    <td>First name : {data.first_name}</td><td>State/Region : {data.state_region}</td>
                </tr>
                    <tr>
                        <td>Last name : {data.last_name}</td><td>Specification : {data.specififcation}</td>
                    </tr>
                    <tr>
                        <td>Email : {data.email || '-'}</td><td>Experience In Above Specification :{data.experiance}</td>
                    </tr>
                    <tr>
                        <td>Phone No : {data.phone_number || '-'}</td><td>Projects You Worked on : {data.experiance}</td>
                    </tr>
                    <tr>
                        <td>Gender : {data.gender || '-'} </td>
                        <td>Resume : <span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + data.resume, "File View", `popup,height=700,width=1000`)} >View</span></td>
                    </tr>
                    <tr>
                        <td>Date of Birth : {data.date_of_birth || '-'}</td><td rowSpan={2}>Profile uploaded : <span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + data.profile_pic, "File View", `popup,height=700,width=1000`)} >View</span></td>
                    </tr>
                    <tr>
                        <td>Current Location :{data.address || '-'}</td>
                    </tr></> : <>
                    <center><h2>Resume not Updated</h2></center>
                </>}
                <tr>
                    <td></td>
                    <td className='all'>
                        <button className="end" onClick={() => setEdit(true)}>{data.first_name != '' ? 'Edit' : 'Fill the Resume'}</button>
                    </td>
                </tr>
            </table>
        </>
    }
    const fileTypes = ["JPG", 'JPEG', "PNG", "GIF"];
    const [file, setFile] = useState(null);
    const handleChange = (file) => {
        setFile(file);
    };
    const fileTypes1 = ["PDF"];
    const [file1, setFile1] = useState(null);
    const handleChange1 = (file) => {
        setFile1(file);
    };
    const getData = async () => {
        await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/resume_module/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                // setData(response.data)
                setData({...response.data,phone_number:response.data.phone_number.slice(2)})
            }).catch(err => {
                // let notify = document.getElementsByClassName('noti')[0];
                // notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                //                 ${err.response.data.message}
                //             </div>`;
                // setTimeout(() => {
                //     notify.removeChild(notify.lastChild)
                // }, 3000);
                console.log(err)
            })
    }
    useEffect(async () => {
        await getData();
    }, [])
    const ResE = () => {
        useEffect(() => {
            // specification ki formdata lo specifification ani undhi , but doc id lo spec ani undhi ,,
            //formdata key vadu , doc id kadhu ,, 
            document.getElementById('first_name').value = data.first_name;
            document.getElementById('state_region').value = data.state_region;
            document.getElementById('last_name').value = data.last_name;
            data.date_of_birth ? document.getElementById('date_of_birth').value = data.date_of_birth : console.log('d');
            // document.getElementsByName('gender').forEach(e=>{if (e.value === data.gender) document.getElementById(data.gender).checked = true});
            // document.getElementsByName('spec').forEach(e=>{if (e.value === data.specifification) document.getElementById(data.specifification).checked = true});
            // document.getElementsByName('exp')forEach(e=>{if (e.value === data.gender) document.getElementById(data.gender).checked = true});
            //document.getElementById('countryCode').value + 
            document.getElementById('phone_number').value = data.phone_number;
            document.getElementById('email').value = data.email;

            document.getElementById('country').value = data.country;
            document.getElementById('address').value = data.address;
        }, [])
        let countries = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
            "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
            "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
            "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad",
            "Chile", "China", "Colombi", "Comoros", "Congo (Brazzaville)", "Congo", "Costa Rica", "Cote d'Ivoire", "Croatia",
            "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor (Timor Timur)",
            "Ecuador", "Egypt", "El Salvador", "Europe", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France",
            "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
            "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
            "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait",
            "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
            "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
            "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar", "Namibia",
            "Nauru", "Nepa", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau",
            "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
            "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe",
            "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
            "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
            "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
            "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
            "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"]

            const [showO, setSo] = useState(false)
        return <table>
            <tr>
                <td> <FileUploader children={
                    <div className='drop-zone'>
                        <p>Profile pic: Click to browse or <br />drag and drop your files{!file ? <><br />{fileTypes.join(', ')}</> : <></>}<br />{file ? `${file.name}` : ""}</p>
                    </div>
                } handleChange={handleChange} name="file" types={fileTypes} />
                    <br /><br />
                </td>
                <td>
                    <FileUploader children={
                        <div className='drop-zone'>
                            <p>Resume : Click to browse or <br />drag and drop your files{!file1 ? <><br />{fileTypes1.join(', ')}</> : <></>}<br />{file1 ? `${file1.name}` : ""}</p>
                        </div>
                    } handleChange={handleChange1} name="file1" types={fileTypes1} />
                    <br /> <br />
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='first_name' name='name' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">First name : </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='state_region' name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">State/Region : </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='last_name' name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Last name : </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='date_of_birth' name='number' class="input__field" type="date" placeholder=" " />
                        <span class="input__label">Date of Birth : </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='email' name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Email : </span>
                    </label>
                </td>
                <td>
                    Country : <select className='CSel lastchange' id='country' >
                        <option value='India'> India </option>
                        {
                            Object.keys(countries).map((item) => (
                                <option value={countries[item]}> {countries[item]} </option>
                            ))
                        }
                    </select>
                </td>
            </tr>
            <tr>
                <td>
                    <div className='changePH' style={{ display: 'flex', justifyContent: 'initial' }}>
                        <select id='countryCode' className='PhoneDW'>
                            {
                                Object.keys(countryCodes).map((item) => (
                                    <option value={countryCodes[item]}>{item} {countryCodes[item]} </option>
                                ))
                            }
                        </select>
                        <label style={{ marginLeft: 0 }} class="input">
                            <input id='phone_number' name='number' class="input__field" type="text" placeholder=" " />
                            <span class="input__label">Phone No : </span>
                        </label>
                    </div>
                </td>
                <td>
                    <label class="input">
                        <input id='address' name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Address : </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    Experience :&emsp;<br />
                    &emsp;<input defaultChecked type="radio" id='l1' name="exp" value="<1" />
                    <label for='l1'>&ensp;&lt;1</label>&emsp;<br />
                    &emsp;<input type="radio" id='l3' name="exp" value="1-3" />
                    <label for='l3'>&ensp;1-3</label>&emsp;<br />
                    &emsp;<input type="radio" id='l5' name="exp" value="3-5" />
                    <label for='l5'>&ensp;3-5</label>&emsp;<br />
                    &emsp;<input type="radio" id='l8' name="exp" value="5-10" />
                    <label for='l8'>&ensp;5-10</label>&emsp;<br />
                    &emsp;<input type="radio" id='l15' name="exp" value="10+" />
                    <label for='l15'>&ensp;10+</label>&emsp;
                </td>
                <td className='SpecResRow'>
                    Specification :&emsp;<br />
                    <div className="row">
                    &emsp;<input type="checkbox" id='CRR' name="SpecNames" value="records review" />
                        <label for='CRR'>Records Review</label></div>
                    <div className="row">
                    &emsp;<input type="checkbox" id='Cpy' name="SpecNames" value="physical" />
                        <label for='Cpy'>Physical</label></div>
                    <div className="row">
                    &emsp;<input onChange={(e) => setSo(e.target.checked ? true : false)} type="checkbox" id='COi' name="SpecNames" value="others" />
                        <label for='COi'>Others</label>
                    </div>
                        {showO ? <>
                            <label class="input">
                        <input id='privSpec' name='spec' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Enter Specification : </span>
                    </label>
                        {/* <input id='privSpec' placeholder='Enter Specification' /> */}
                        
                        </> : <></>}<br/>
                    {/* &emsp;<input defaultChecked type="radio" id='srev' name="spec" value="records review" />
                    <label for="srev">&ensp;Records Review</label>&emsp;<br />
                    &emsp;<input type="radio" id='sphy' name="spec" value="physical" />
                    <label for="sphy">&ensp;Physical</label>&emsp;<br />
                    &emsp;<input type="radio" id='soth' name="spec" value="other" />
                    <label for="soth">&ensp;Other</label>&emsp;<br /> */}
                    Gender : &emsp;<br />
                    &emsp;<input defaultChecked type="radio" id='male' name="gender" value="male" />
                    <label for="male">&ensp;Male</label>&emsp;<br />
                    &emsp;<input type="radio" id='female' name="gender" value="female" />
                    <label for="female">&ensp;Female</label>&emsp;<br />
                    &emsp;<input type="radio" id='other' name="gender" value="other" />
                    <label for="other">&ensp;Other</label>&emsp;
                </td>
            </tr>
            <tr>
                <td></td>
                <td className='all'>
                    <button className="end" onClick={(e) => { submit(e) }}>Submit</button>
                </td>
            </tr>
        </table>
    }
    const [data, setData] = useState({
        first_name: '',
        state_region: '',
        last_name: '',
        date_of_birth: '',
        experiance: '',
        gender: '',
        phone_number: '',
        email: '',
        country: '',
        address: '',
        specifification: '',
        profile_pic: '',
        resume: '',
    })
    async function submit(e) {
        var formData = new FormData();
        formData.append('first_name', document.getElementById('first_name').value);
        formData.append('state_region', document.getElementById('state_region').value);
        formData.append('last_name', document.getElementById('last_name').value);
        formData.append('date_of_birth', document.getElementById('date_of_birth').value);
        document.getElementsByName('gender').forEach(e => { if (e.checked) formData.append('gender', e.value) })
        // document.getElementsByName('spec').forEach(e => { if (e.checked) formData.append('specififcation', e.value) })
        
        let specs = document.getElementsByName('SpecNames');
        let valuesf=[]
        for(let i=0;i<2;i++)
            if (specs[i].checked)valuesf.push(specs[i].value)
        if (specs[2].checked) valuesf.push(document.getElementById('privSpec').value);
        console.log(valuesf)
        formData.append('specififcation', valuesf.join(', '))
        document.getElementsByName('exp').forEach(e => { if (e.checked) formData.append('experiance', e.value) })
        formData.append('phone_number', document.getElementById('countryCode').value + document.getElementById('phone_number').value);
        formData.append('email', document.getElementById('email').value);
        formData.append('country', document.getElementById('country').value);
        formData.append('address', document.getElementById('address').value);
        formData.append('profile_pic', file);
        formData.append('resume', file1);
        e.target.style.cursor = 'wait'
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL1}/consultant/resume_module/`,
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            },
        }).then(async response => {
            await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/resume_module/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                }
            })
                .then(response => {
                    e.target.style.cursor = 'unset'
                    setData({...response.data,phone_number:response.data.phone_number.slice(2)})
                    setEdit(false)
                }).catch(err => {
                    console.log(err)
                })
        }).catch(err => {
            console.log(err)
            console.log(formData)
        })
        console.log(formData.get('date_of_birth'))
    }
    return (
        <div>
            {edit ?
                <div className='resume'>
                    <ResE />
                </div> :
                <div className='resume-details'>
                    <ResDet />
                </div>
            }
        </div>
    )
}
